import initialStates from '../storeInitialState';
import {
  UPDATE_METADATA,
  METADATA_LOADED_SUCCESSFULLY,
  METADATA_LOADING,
} from '../actions/types';

const metadata = (state = initialStates.metadata, action) => {
  switch (action.type) {
    case METADATA_LOADING:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    case METADATA_LOADED_SUCCESSFULLY:
      return {
        ...state,
        object: action.payload.metadata,
      };
    case UPDATE_METADATA:
      return {
        ...state,
        object: action.payload.metadata,
      };
    default:
      return state;
  }
};
export default metadata;
